import type { INumbersRecord } from "app/pages/industry-analysis/players/table/types";
import type { ITHRESHOLD } from "app/pages/industry-analysis/players/rising-and-declining-players/types";

export const RECORDS_AMOUNT = 5;

export const CHANGE_ATTRIBUTE: keyof INumbersRecord = "AvgUniqueUsersPeriodChange";
export const POP_CHANGE_ATTRIBUTE: keyof INumbersRecord = "AvgUniqueUsersCompareChange";

export const THRESHOLD: ITHRESHOLD = { attribute: "AvgUniqueUsers", value: 5000 };
